/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     PrintView.js
//   Details:    PrintView.js
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 105066 06/01/20 JC  M01  Added font awesome
// 104762 02/03/20 JC  M02  Notices can now pass html rather than a note
// 103839 06/04/20 JC  M03  React upgrade
// 108238 08/06/20 JC  M04  Re-wrote datetime components
//-------------------------------------------------------
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//M04 import DateTimeLabel from './DateTimeLabel'; //M04
import DateTime from './DateTime'; //M04
import { dateTimeTypes } from '../constants/DateTimeTypes'; //M04
import { Button } from 'react-bootstrap'; //M01 removed glyphicon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M01
import { itemTypes } from '../constants/ItemTypes'; //M02
import { noteTypes } from '../constants/NoteTypes'; //M02
import { utils } from '../utils/utils'; //M02
import './css/PrintView.css';

class PrintView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false
		};

		this.handlePrint = this.handlePrint.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	handlePrint = event => {
		event.preventDefault();
		window.print();
	}

	handleClose = event => {
		event.preventDefault();
		this.props.closeView();
	}

	render() {
		const { item } = this.props;

		return (
			<div className="print-view">
				<div className="print-view-controls">
          <Button
            className="btn btn-default"
						bsSize="large"
						type="button"
						onClick={this.handlePrint}
					>
                        <FontAwesomeIcon icon="print" /> Print{/* M01 */}
					</Button>
          <Button
            className="btn btn-default"
						size="lg"
						type="button"
						onClick={this.handleClose}
					>
                        <FontAwesomeIcon icon="times-circle" /> Close{/* M01 */}
					</Button>
				</div>

				<h1>{item.subject}</h1>
				<h2>{item.typeName}</h2>
                <h3><DateTime value={item.postedDate} dateTimeType={dateTimeTypes.dateTime} disabled={true}/></h3> {/*M04*/}

                {item.itemType === itemTypes.notice && item.noteType === noteTypes.html
                    ?                    
                        /* M02 notice only if html - set passed in html */
                        <div dangerouslySetInnerHTML={utils.getSafeHTML(item.noteHTMLContent)} />
                    : 
                    /* M02 everything else just split the note */
                    item.note.split('\n').map((i, k) => {
                        return <span>{i}<br /></span>;
                    })
                }

			</div>
		);
	}
}

PrintView.propTypes = {
	item: PropTypes.shape({
		subject: PropTypes.string,
		typeName: PropTypes.string, //M02 no longer required isRequired,
        postedDate: PropTypes.instanceOf(Date), //M03 was PropTypes.DateTime,
		note: PropTypes.string,
        itemType: PropTypes.oneOf([itemTypes.notice]) //M02 was ['noticeType']
	}),
	closeView: PropTypes.func.isRequired
};

export default connect()(PrintView);
